// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__287pI","cell":"ColumnAccessor_cell__3MhzV","firstCellAccent":"ColumnAccessor_firstCellAccent__2CXMT"};